<ul class="nav nav-tabs mb-3">
  <li class="nav-item">
    <a class="nav-link" [class.active]="activeTab === 'mbqDraftList'" (click)="setTab('mbqDraftList')">
      MBQ Draft List
    </a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [class.active]="activeTab === 'mbqList'" (click)="setTab('mbqList')">
      MBQ
    </a>
  </li>
</ul>
@if (activeTab === 'mbqDraftList') {
<div class="content-info">
  <div class="content-title d-flex justify-content-between align-items-center">
    <h3 class="title">MBQ</h3>
    <div class="title-actions d-flex align-items-center gap-2">
      <!-- Consolidated Downloads Dropdown -->
      <div class="dropdown d-inline-block">
        <button class="btn btn-success dropdown-toggle" type="button" id="downloadsDropdown" data-bs-toggle="dropdown"
          aria-expanded="false">
          <i class="bi bi-download"></i> Downloads
        </button>

        <ul class="dropdown-menu" aria-labelledby="downloadsDropdown">
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="downloadTemplate()">
              Download MBQ Template
            </a>
          </li>
        </ul>
      </div>

      <!-- Hidden File Input -->
      <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept=".xlsx, .xls" />

      <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search by MBq"
        class="form-control" style="width: 200px" />

      <button class="btn btnprimary me-2" [routerLink]="['/mbq/upload']">
        <i class="bi bi-plus-lg"></i> Upload MBQ
      </button>
    </div>
  </div>

  <div class="common-table mt-3">
    <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th>MBQ No</th>
            <th>Status</th>
            <th>File Name</th>
            <th>Total Lines</th>
            <th>Created At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="6" class="text-center">Loading replenishments...</td>
          </tr>

          <tr *ngIf="!loading && draftList.length === 0">
            <td colspan="6" class="text-center">No replenishment drafts found.</td>
          </tr>

          <tr *ngFor="let r of draftList">
            <td>
              <a [routerLink]="['/mbq/upload', r.id]" [queryParams]="{ view: true }">
                {{ r.replenishmentNumber || "—" }}
              </a>
            </td>

            <td>
              <span class="badge" [ngClass]="{
          'bg-warning': r.status === 'DRAFT',
          'bg-success': r.status === 'SUBMITTED',
          'bg-danger': r.status === 'CANCELLED',
          'bg-secondary': r.status === 'EXPIRED'
        }">
                {{ r.status }}
              </span>
            </td>
            <td>{{ r.fileName || '—' }}</td>
            <td>{{ r.itemsCount || 0 }}</td>


            <td>{{ r.createdAt | date : 'dd-MM-yy HH:mm' }}</td>

            <td>
              <div class="td-actions-btn d-flex gap-1">
                <button *ngIf="r.status === 'DRAFT'" class="btn btn-edit" [routerLink]="['/mbq/upload', r.id]">
                  <i class="bi bi-pencil-square"></i>
                </button>

                <button *ngIf="r.status === 'DRAFT'" class="btn btn-delete" (click)="deleteStockTake(r.id)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>

      </table>
    </div>

    <div class="table-pagination">
      <!-- Entries per page selector -->
      <div class="pagination-count">
        <select class="form-select" [(ngModel)]="pageSize" (change)="pageSizeChange()">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="50">50</option>
        </select>
        <span>entries per page</span>
      </div>

      <ul class="pagination">
        <!-- Previous button -->
        <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <a class="page-link">&laquo;</a>
        </li>

        <!-- First Page button -->
        <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
          <a class="page-link">1</a>
        </li>

        <!-- Left Ellipsis -->
        @if (currentPage > 4) {
        <li class="page-item disabled">
          <a class="page-link">...</a>
        </li>
        }

        <!-- Pages Around Current page -->
        @for (page of getVisiblePages(); track page) {
        <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
          <a class="page-link">{{ page }}</a>
        </li>
        }

        <!-- Right Ellipsis -->
        @if (currentPage < pageCount - 3) { <li class="page-item disabled">
          <a class="page-link">...</a>
          </li>
          }

          <!-- Last Page button - only show if more than 1 page -->
          @if (pageCount > 1) {
          <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
            <a class="page-link">{{ pageCount }}</a>
          </li>
          }

          <!-- Next button -->
          <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="goToPage(currentPage + 1)">
            <a class="page-link">&raquo;</a>
          </li>
      </ul>
    </div>
  </div>
</div>
}

@if (activeTab === 'mbqList') {
<div class="content-info">
  <app-mbq></app-mbq>>
</div>
}